export const createVariant = (resolver) => {
    return (calculator) => (props) => {
        const resolvedBranch = resolver(props)(props);
        return calculator ? calculator(resolvedBranch, props) : resolvedBranch;
    };
};
//# sourceMappingURL=createVariant.js.map